import { createCourseCard } from '../../../../pages/catalog/assets/js/templates/course-card';
import type { Course } from '../types';
import { createLogger, LogLevel } from '../../../../pages/catalog/assets/js/utils/logger';
import { getCourseLinkById } from '../../../../pages/catalog/assets/js/utils/course-by-id';

const logger = createLogger('CoursesModalRenderer', LogLevel.INFO);

export function renderCoursesModal(courses: Course[], aboutTitle?: string): HTMLElement | null {
  logger.info('Начало рендера модалки курсов');
  logger.info(`Количество курсов для отображения: ${courses.length}`);
  if (courses.length === 1) {
    const courseId = courses[0].id;
    const permalink = getCourseLinkById(courseId);
    if (permalink) {
      logger.info('Один курс, редиректим на:', permalink);
      window.location.href = permalink;
      return null;
    } else {
      logger.warn('Permalink для курса не найден, продолжаем рендерить модалку');
    }
  }
  if (!courses.length) {
    logger.warn('Нет курсов для отображения в модалке!');
  }
  // Генерируем только .courses__modal, без modal/modal__content
  const modal = document.createElement('div');
  modal.className = 'courses__modal';

  // Header
  const header = document.createElement('div');
  header.className = 'modal__header';
  const titleWrap = document.createElement('div');
  titleWrap.className = 'modal__title';
  const title = document.createElement('p');
  title.className = 'title';
  title.textContent = 'Выбери курс';
  titleWrap.appendChild(title);
  if (aboutTitle) {
    const desc = document.createElement('p');
    desc.className = 'description';
    desc.textContent = aboutTitle;
    titleWrap.appendChild(desc);
  }
  header.appendChild(titleWrap);
  // Кнопка закрытия (svg)
  const closeBtn = document.createElement('div');
  closeBtn.innerHTML = `<svg class="close__modal" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.002 13.8281L22.8291 20.001L29.001 26.1729L26.1729 29.002L20.001 22.8291L13.8291 29.002L11.001 26.1729L17.1719 20.001L11 13.8281L13.8281 11L20.001 17.1729L26.1738 11L29.002 13.8281Z" fill="#808080"/></svg>`;
  closeBtn.className = 'close__modal';
  header.appendChild(closeBtn);
  modal.appendChild(header);

  // Body
  const body = document.createElement('div');
  body.className = 'modal__body';

  // Slider controls (prev/next)
  if (courses.length > 3) {
    const sliderControls = document.createElement('div');
    sliderControls.className = 'slider-controls';
    sliderControls.innerHTML = `
      <svg class="swiper-prev" width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2081_38277)"><path d="M58.2273 28.0717C59.575 43.4768 48.1793 57.0577 32.7742 58.4055C17.369 59.7533 3.78814 48.3575 2.44036 32.9524C1.09259 17.5473 12.4883 3.96637 27.8935 2.6186C43.2986 1.27082 56.8795 12.6666 58.2273 28.0717Z" fill="#775AFA" /><ellipse cx="24.0006" cy="23.9994" rx="24.0006" ry="23.9994" transform="matrix(0.996171 -0.0871536 0.0849163 0.996412 4.33203 8.69531)" stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-dasharray="3.36 3.36" /><path d="M31.479 21.2912L25.0376 28.9678L41.1479 27.5583L41.4965 31.5431L25.3862 32.9526L33.0628 39.394L30.4919 42.4578L19.1167 32.9129L18.8702 30.0955L28.4151 18.7204L31.479 21.2912Z" fill="white" /></g><defs><clipPath id="clip0_2081_38277"><rect width="56" height="56" fill="white" transform="translate(0 5.05896) rotate(-5)" /></clipPath></defs></svg>
      <svg class="slider-next" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2081_38278)"><path d="M58.9753 28.3194C60.3231 43.7245 48.9273 57.3054 33.5222 58.6532C18.1171 60.001 4.53618 48.6052 3.18841 33.2001C1.84063 17.795 13.2364 4.21405 28.6415 2.86628C44.0466 1.51851 57.6275 12.9142 58.9753 28.3194Z" fill="#775AFA" /><ellipse cx="24.8895" cy="24.8883" rx="24.8895" ry="24.8883" transform="matrix(0.996171 -0.0871536 0.0849163 0.996412 4.11914 8.13477)" stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-dasharray="3.36 3.36" /><path d="M42.2986 28.3589L42.5451 31.1763L33.0002 42.5515L29.9363 39.9806L36.3777 32.3041L20.2674 33.7135L19.9188 29.7288L36.0291 28.3193L28.3525 21.8779L30.9234 18.814L42.2986 28.3589Z" fill="white" /></g><defs><clipPath id="clip0_2081_38278"><rect width="56" height="56" fill="white" transform="translate(0.748047 5.30664) rotate(-5)" /></clipPath></defs></svg>
    `;
    body.appendChild(sliderControls);
  }

  if (courses.length) {
    // Слайдер с карточками
    const slider = document.createElement('div');
    // Если курсов 1 или меньше — не инициализируем Swiper, добавляем not-swiper
    if (courses.length <= 1) {
      slider.className = 'courses__slider not-swiper';
    } else {
      slider.className = 'courses__slider swiper';
    }
    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';
    courses.forEach(course => {
      logger.debug('Рендерим карточку курса:', course);
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(createCourseCard(course));
      wrapper.appendChild(slide);
    });
    slider.appendChild(wrapper);
    body.appendChild(slider);

    // Индикатор и пагинация
    if (courses.length > 3) {
      const indicator = document.createElement('div');
      indicator.className = 'swiper__indicator';
      const progress = document.createElement('div');
      progress.className = 'swiper__indicator__progress';
      indicator.appendChild(progress);
      body.appendChild(indicator);
    }
    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    body.appendChild(pagination);
  } else {
    // Если курсов нет — выводим сообщение
    const empty = document.createElement('p');
    empty.className = 'error-message';
    empty.textContent = 'Курсы не найдены';
    body.appendChild(empty);
  }

  modal.appendChild(body);

  // Footer
  const footer = document.createElement('div');
  footer.className = 'modal__footer';
  footer.innerHTML = `<p>Нужна помощь с выбором?</p><p data-action="callback-modal">Оставить заявку</p>`;
  modal.appendChild(footer);

  logger.info('Рендер модалки курсов завершён');
  logger.info('HTML модалки:', modal.outerHTML);
  return modal;
} 